import React from 'react';
import { Button } from '@global-ecom/nitro-uds/elements';

import { FilterOption } from '__generated__/graphql';
import { useTranslate } from 'hooks/useTranslations';
import { AccordionRoot, AccordionTab } from 'ui/elements/Accordion';
import { ProductListClearAllFilters } from 'ui/components/ProductListClearAllFilters';
import Modal from 'ui/components/Modal';
import { getFilterComponent } from 'ui/components/ProductListFilterDropdown';
import { ManagedHeading } from 'ui/components/ManagedHeading';

import { useProductListFilterContext } from './ProductListFilterProvider';
import CloseButton from './CloseButton';
type Props = {
  onClose: () => void;
  items: FilterOption[];
  totalCount: number;
};

export const ProductListFilterDrawer = ({
  onClose,
  items,
  totalCount,
}: Props) => {
  const t = useTranslate();
  const { isFetching } = useProductListFilterContext();
  const { handlePriceSliderSubmit } = useProductListFilterContext();

  return (
    <Modal
      key="draw-filter"
      dataTestId="filter-modal"
      layout="drawerLeft"
      variant="dark"
      onClickOutside={onClose}
      className="flex flex-col items-center min-h-screen"
    >
      <div className="w-full relative flex items-center justify-between border-b p-6">
        <ManagedHeading
          tag="h1"
          className="inline-block text-left text-xl font-bold capitalize"
        >
          {t('productFilters')}
        </ManagedHeading>
        <CloseButton dataTestId="close-filters-btn" onClick={onClose} />
      </div>
      <div className="w-full flex flex-1 flex-col px-6 pb-4">
        <AccordionRoot>
          {items.map(item => (
            <AccordionTab
              title={item.label}
              id={item.id}
              key={item.id}
              expand={false}
              bodyClassNameConfig={{
                baseClassName: 'py-4',
              }}
              headerClassNameConfig={{
                baseClassName: 'text-lg font-semibold pt-2 pb-4 capitalize',
              }}
            >
              <div>
                {getFilterComponent({ data: item, isFromDrawer: true })}
              </div>
            </AccordionTab>
          ))}
        </AccordionRoot>
      </div>
      <div className="sticky bottom-0 w-full flex flex-col items-center bg-white px-6 py-4 shadow-2xl">
        <ProductListClearAllFilters />
        <Button
          dataTestId="product-list-drawer-btn"
          label={t<'showProducts'>('showProducts', {
            count: totalCount,
          })}
          className="mt-6 w-full"
          variant="primary"
          onClick={() => {
            handlePriceSliderSubmit();
            onClose();
          }}
          size="lg"
          disabled={isFetching}
        />
      </div>
    </Modal>
  );
};
